import React, { useState, useEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Helmet from "react-helmet";

//imported
import Header from "components/layout/Header";
import Sidebar from "components/layout/Sidebar";
import Footer from "components/layout/Footer";
import { useSelector } from "react-redux";
import { initializeSocket } from "helpers/socket";

const Layout = () => {
  const { user } = useSelector((state) => state.Auth);
  const userId = user?.id;
  
  useEffect(() => {
    if (userId) {
      initializeSocket(userId);
    }
  }, [userId]);
  return (
    <>
      <div className="w-100 d-flex adminLayout">
        <Sidebar type={"dashboard"} />
        <div className="main-wrapper">
          <Helmet titleTemplate={`%s | ${process.env.REACT_APP_APPNAME}`} />
          <Header />
          <div
            id="main-content"
            className="main-content"
            style={{
              height: "calc(100vh - 120px)",
              overflowY: "scroll",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {/* <div className="main-content" style={{ minHeight: "705px" }}> */}
            <Outlet />
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Layout;
